<div class="block-page-title">
    <h2 class="page-title">Мои курсы</h2>
</div>
<courses-list [privateCourse]="privateCourse"></courses-list>